export const OPTHINES = {
  voteName: '2020project/2020community',
  themeColor: {
    activeBgColor: 'rgb(27, 88, 169)',
    inactiveBgColor: '#fff',
  },
  tabs: [
    {
      tabName: '首页',
      tabPath: '/20200909CQZM/give-like',
    },
    {
      tabName: '点赞规则',
      tabPath: '/20200909CQZM/likerules',
    },
    {
      tabName: '相关新闻',
      tabPath: '/20200909CQZM/news',
    },

    {
      tabName: '活动介绍',
      tabPath: '/20200909CQZM/rules',
    },
  ],

  tabConfArr: [
    {
      id: 1,
      text: '最美环卫工',
      type: 1,
    },
    {
      id: 2,
      text: '最美城市管理志愿者',
      type: 2,
    },
    {
      id: 3,
      text: '最美坡坎崖',
      type: 3,
    },
    {
      id: 7,
      text: '垃圾分类示范社区',
      type: 7,
    },
    {
      id: 8,
      text: '垃圾分类时尚小区',
      type: 8,
    },
    {
      id: 9,
      text: '垃圾分类示范村',
      type: 9,
    },
    {
      id: 4,
      text: '最美公园',
      type: 4,
    },
    {
      id: 5,
      text: '最美街巷',
      type: 5,
    },
    {
      id: 6,
      text: '最美人行道',
      type: 6,
    },
  ],
};
